import { render } from "./SkeletonForDashboard.vue?vue&type=template&id=cadd0006&scoped=true"
import script from "./SkeletonForDashboard.vue?vue&type=script&lang=js"
export * from "./SkeletonForDashboard.vue?vue&type=script&lang=js"

import "./SkeletonForDashboard.vue?vue&type=style&index=0&id=cadd0006&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/@vue+cli-service@5.0.9_@vue+compiler-sfc@3.5.26_lodash@4.17.21_sass-loader@13.3.3_node-_2efde1b6c902023e3f10239734cd10e2/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadd0006"]])

export default __exports__